// Action types (classic Redux)
export const CACHE_BEGIN = "cachedApi/BEGIN";
export const CACHE_SUCCESS = "cachedApi/SUCCESS";
export const CACHE_FAILURE = "cachedApi/FAILURE";
export const CACHE_CLEAR = "cachedApi/CLEAR";
export const CACHE_CLEAR_PREFIX = "cachedApi/CLEAR_PREFIX";

// Action creators
export const cacheBegin = (key, requestId, ttlMs) => ({
  type: CACHE_BEGIN,
  payload: { key, requestId, ttlMs },
});

export const cacheSuccess = (key, requestId, data) => ({
  type: CACHE_SUCCESS,
  payload: { key, requestId, data },
});

export const cacheFailure = (key, requestId, error) => ({
  type: CACHE_FAILURE,
  payload: { key, requestId, error },
});

export const cacheClear = (key) => ({ type: CACHE_CLEAR, payload: { key } });

export const cacheClearPrefix = (prefix) => ({
  type: CACHE_CLEAR_PREFIX,
  payload: { prefix },
});
